export default function Text(params) {
  var _params$innerMethods;
  const textCell = document.createElement('div');
  textCell.classList.add('w5-text-cell');
  let value = params.value;
  if (!value) {
    return textCell;
  }
  if (params.textFromAttribute && value[params.textFromAttribute]) {
    value = value[params.textFromAttribute];
  }
  if (params.upperCase) textCell.classList.add('w5-text-cell--uppercase');
  if (params.trimText) {
    value = value.replace(/(\r\n|\n|\r)/gm, '');
  }
  if (params !== null && params !== void 0 && (_params$innerMethods = params.innerMethods) !== null && _params$innerMethods !== void 0 && _params$innerMethods.formatText) {
    value = params.innerMethods.formatText(value);
  }
  textCell.innerText = value;
  return textCell;
}